import {UUID} from '../../../shared/types/uuid.type';
import {createReducer, on} from '@ngrx/store';
import {
  clearClipsState,
  clipStatusUpdated,
  clipUpdated,
  loadClips,
  loadClipsFailure,
  loadClipsSuccess,
  manyClipsDeleted
} from '../actions/clips.actions';
import {Clip, ClipStatus} from '../../../services/api/clips/clip.model';

export const clipsFeatureKey = 'clips';

export interface State {
  record: Clip[];
  error: any | null;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: [],
  error: null,
  loaded: false,
  loading: false
};

export const reducer = createReducer(
  initialState,

  on(loadClips, (): State => ({
    record: [],
    error: null,
    loaded: false,
    loading: true
  })),
  on(loadClipsSuccess, (_state: State, action: { data: Clip[] }): State => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false
  })),
  on(loadClipsFailure, (_state: State, action: { error: any }): State => ({
    record: [],
    error: action.error,
    loaded: false,
    loading: false
  })),
  on(clipUpdated, (state: State, action: { data: Clip }): State => {
    const updatedClip: Clip = action.data;
    const updatedClipId: UUID = updatedClip.id;

    const clips: Clip[] = state.record
      .map((clip: Clip): Clip => {
        const id: UUID = clip.id;
        if (id === updatedClipId) {
          return updatedClip;
        }

        return clip;
      });

    return {
      record: clips,
      error: null,
      loaded: true,
      loading: false
    };
  }),
  on(clipStatusUpdated, (state: State, action: { id: UUID, status: ClipStatus }): State => {
    const updatedClipId: UUID = action.id;
    const updatedClipStatus: ClipStatus = action.status;

    const clips: Clip[] = state.record
      .map((clip: Clip): Clip => {
        const id: UUID = clip.id;
        if (id === updatedClipId) {
          return {
            ...clip,
            status: updatedClipStatus
          };
        }

        return clip;
      });

    return {
      record: clips,
      error: null,
      loaded: true,
      loading: false
    };
  }),
  on(manyClipsDeleted, (state: State, action: { ids: UUID[] }): State => {
    const actionAsString: string = JSON.stringify(action);
    console.debug(`manyClipsDeleted action: ${actionAsString}`);
    const ids: string[] = action.ids;

    const clips: Clip[] = state.record
      .filter((clip: Clip): boolean => {
        const id: UUID = clip.id;
        return !ids.includes(id);
      });

    return {
      record: clips,
      error: null,
      loaded: true,
      loading: false
    };
  }),
  on(clearClipsState, (): State => ({
    record: [],
    error: null,
    loaded: false,
    loading: false
  }))
);
